export enum CategoryOfChange {
  CATEGORY_A = 'CATEGORY_A',
  CATEGORY_B = 'CATEGORY_B',
  CATEGORY_C = 'CATEGORY_C',
  CATEGORY_D = 'CATEGORY_D',
}
